<template>
  <van-row class="page-wrapper" justify="center">
    <!-- Используем наш новый компонент списка -->
    <payment-history-list />
  </van-row>
</template>

<script>
// Импортируем новый компонент
import PaymentHistoryList from "@/components/history/PaymentHistoryList";

export default {
  name: "PaymentHistory", // Изменил имя для ясности
  components: { PaymentHistoryList },
};
</script>
